// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sg2VBbG9QFU5fVcwp9t2 {
    width: 100%;
    min-height: var(--footer-height);
    height: var(--footer-height);
}

.abp9FEQofDrepFQ3pIQr {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Layout/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,WAAW;AACf","sourcesContent":[".footer {\n    width: 100%;\n    min-height: var(--footer-height);\n    height: var(--footer-height);\n}\n\n.divider {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Sg2VBbG9QFU5fVcwp9t2`,
	"divider": `abp9FEQofDrepFQ3pIQr`
};
export default ___CSS_LOADER_EXPORT___;
